import _toConsumableArray from "/Users/tzachyarimi/projects/faintlines/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
var CC_REGEX = /^[a-z]{2}$/i;
var FLAG_LENGTH = 4;
var OFFSET = 127397;

function countryCodeEmoji(cc) {
  if (!CC_REGEX.test(cc)) {
    var type = typeof cc;
    throw new TypeError("cc argument must be an ISO 3166-1 alpha-2 string, but got '".concat(type === "string" ? cc : type, "' instead."));
  }

  var codePoints = _toConsumableArray(cc.toUpperCase()).map(function (c) {
    return c.codePointAt() + OFFSET;
  });

  return String.fromCodePoint.apply(String, _toConsumableArray(codePoints));
}

function emojiCountryCode(flag) {
  if (flag.length !== FLAG_LENGTH) {
    var type = typeof flag;
    throw new TypeError("flag argument must be a flag emoji, but got '".concat(type === "string" ? flag : type, "' instead."));
  }

  var codePoints = _toConsumableArray(flag).map(function (c) {
    return c.codePointAt() - OFFSET;
  });

  return String.fromCodePoint.apply(String, _toConsumableArray(codePoints));
}

var src_default = countryCodeEmoji;
export { countryCodeEmoji, src_default as default, emojiCountryCode };